module.exports = __webpack_public_path__ + "static/car10-bc3cf97d8733368a8277f76e5ed2e78d.png";